<script>
  import { onMount, onDestroy } from 'svelte';

  let { token, baseUrl, onselect } = $props();

  const GEOWIDGET_SCRIPT_URL = `${baseUrl}/inpost-geowidget.js`;
  const GEOWIDGET_CSS_URL    = `${baseUrl}/inpost-geowidget.css`;

  const callbackName = `_inpostCallback_${Math.random().toString(36).slice(2)}`;

  let container;

  onMount(() => {
    window[callbackName] = handlePoint;
    loadStyles();
    loadScript();

    // Create element programmatically so all attributes are set before insertion.
    // When the script is already loaded the custom element upgrades immediately on
    // connectedCallback — if we insert first and setAttribute second, the widget
    // reads onpoint before we set it and the callback is never wired up.
    const widget = document.createElement('inpost-geowidget');
    widget.setAttribute('token', token);
    widget.setAttribute('language', 'pl');
    widget.setAttribute('config', 'parcelcollect');
    widget.setAttribute('onpoint', callbackName);
    container.appendChild(widget);
  });

  onDestroy(() => {
    delete window[callbackName];
  });

  const handlePoint = (point) => {
    if (!point) return;
    const address = [point.address?.line1, point.address?.line2].filter(Boolean).join(', ');
    onselect?.({ name: point.name, address });
  };

  const loadStyles = () => {
    if (document.querySelector(`link[href="${GEOWIDGET_CSS_URL}"]`)) return;
    const link = document.createElement('link');
    link.rel  = 'stylesheet';
    link.href = GEOWIDGET_CSS_URL;
    document.head.appendChild(link);
  };

  const loadScript = () => {
    if (document.querySelector(`script[src="${GEOWIDGET_SCRIPT_URL}"]`)) return;
    const script = document.createElement('script');
    script.src = GEOWIDGET_SCRIPT_URL;
    document.head.appendChild(script);
  };
</script>


<div class="geowidget" bind:this={container}></div>


<style>
  .geowidget {
    width: 100%;
    height: 540px;
  }

  .geowidget :global(inpost-geowidget) {
    display: block;
    width: 100%;
    height: 100%;
  }
</style>
